import { Component, Injector, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent } from '../../../common/BaseComponent';
import { UserRoleDetails } from 'src/app/model/userRoleDetails';
import { User } from 'src/app/model/user';
@Component({
  selector: 'app-admin-reset-password-complete',
  templateUrl: './reset-password-complete.component.html',
  styles: [
  ]
})
export class AdminResetPasswordCompleteComponent extends BaseComponent implements OnInit {
  userRoleDetails: UserRoleDetails;
  user: User;
  operation: number;
  storedCode: string;
  constructor(
    injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    const storedOperation = sessionStorage.getItem("operation");
    this.storedCode = sessionStorage.getItem("code");
    if(storedOperation){
      this.operation = parseInt(storedOperation, 10);
    }
    const sessionUserRole = sessionStorage.getItem("selectedUserRole");
    this.userRoleDetails = JSON.parse(sessionUserRole);
    this.user = this.userRoleDetails.user;
    // this.restSub = this.rest.sendEmailMFA(this.user).subscribe(response => {
    //   console.log("pass-change-send-email:" + JSON.stringify(response));
    //   if (response.result == 1) {
    //     this.appError = true;
    //     this.appErrorMessage = this.appErrorPrefix + "." + response.error_code;
    //   } else {
    //     this.appError = false;

    //     this.appSuccess = true;
    //     this.appSuccessMessage = this.getMessage("bss.user.email.update.otp.sent.success");
    //   }
    // }, (error) => { this.processError(error) });
    this.appSuccess = true;
    if(this.operation == 0){
      this.appSuccessMessage = "bss.admin.resetPassword.complete.success";
    }else{
      this.appSuccessMessage = "bss.admin.resetPassword.MPR.complete.success";
    }
    
  }

  // OnSubmit()
  onSubmit(): void {
    sessionStorage.removeItem("searchUserRole");
    sessionStorage.removeItem("code");
    sessionStorage.removeItem("operation");
    this.router.navigate(['secure/paadmin/role/search']);
  }
  setAccess():void{
    this.router.navigate(['secure/paddmin/manageuseremailaccess']);
  }


}